// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__6aF6p","fileBtn":"File_fileBtn__GBu7y","closeBtn":"File_closeBtn__3si7h","fileSelected":"File_fileSelected__2OQai","disabled":"File_disabled__1wb8f"};